<template>
  <header id="topnav">
    <div class="topbar-main">
      <div class="container-fluid">
        <div class="logo">
          <router-link :to="{name: 'home'}" class="text-white">
            <img src="@/assets/logo_urba_trasp.png" style="height: 30px;">           
          </router-link>
        </div>
        <div class="menu-extras topbar-custom">
          <ul class="list-inline float-right mb-0">
            <li class="menu-item list-inline-item">
              <a class="navbar-toggle nav-link">
                <div class="lines">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </a>
            </li>
            <li class="list-inline-item dropdown notification-list" v-if="false">
              <a
                class="nav-link dropdown-toggle arrow-none waves-effect"
                @click="showNotifications()"
              >
                <i class="mdi mdi-bell noti-icon"></i>
                <span class="badge badge-pink noti-icon-badge">{{ notifications.length }}</span>
              </a>
            </li>

            <li class="list-inline-item dropdown notification-list" v-if="false">
              <a
                class="nav-link dropdown-toggle waves-effect nav-user"
                @click="platformLogout()"
              >
                <img src="../assets/logo_urba_trasp.png" alt="user" class="rounded-circle" />
              </a>              
            </li>
          </ul>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="navbar-custom">
      <div class="container-fluid">
        <div id="navigation">
          <ul class="navigation-menu">
            <li class="has-submenu" :class="[{'active': activeDirectory=='home'}]">
              <router-link :to="{name:'home'}">
                <i class="ti-home"></i>Homepage
              </router-link>
            </li>
            <!-- Mappa -->
            <li class="has-submenu" :class="[{'active': activeDirectory=='map'}]">
              <router-link :to="{name:'realtime-map'}">
                <i class="ti-map"></i>Mappa
              </router-link>
            </li>
            <!-- Storico -->
            <li class="has-submenu" :class="[{'active': activeDirectory=='storico'}]">
              <a href="#">
                <i class="ti-list"></i>Mostra
              </a>
              <ul class="submenu">
                <li :class="[{'active': activePage=='segnalazioni'}]">
                  <router-link :to="{ name: 'history', params: { scope: 'segnalazioni' }}" >Segnalazioni</router-link>
                </li>
                <li :class="[{'active': activePage=='richieste'}]">
                  <router-link :to="{ name: 'history', params: { scope: 'richieste' }}" >Richieste di supporto</router-link>
                </li>
                <li :class="[{'active': activePage=='lavori'}]">
                  <router-link :to="{ name: 'history', params: { scope: 'lavori' }}" >Lavori</router-link>
                </li>
              </ul>
            </li>            
            <!-- Dati -->
            <li class="has-submenu" :class="[{'active': activeDirectory=='dati'}]">
              <a href="#">
                <i class="ti-download"></i>Dati
              </a>
              <ul class="submenu">
                <li :class="[{'active': activePage=='geo-data'}]">
                  <router-link :to="{name: 'geo-data'}" >Dati geografici</router-link>
                </li>
                <li>
                  <router-link :to="{name: 'reports'}">Report giornaliero</router-link>
                </li>
              </ul>
            </li>
            <!-- Amministrazione -->
            <li class="has-submenu" :class="[{'active': activeDirectory=='admin'}]" v-if="tipologia=='B'">
              <a href="#">
                <i class="ti-key"></i>Amministrazione
              </a>
              <ul class="submenu">
                <li :class="[{'active': activePage=='admin-users'}]">
                  <router-link :to="{name: 'admin-users'}" >Utenti</router-link>
                </li>
                 <li :class="[{'active': activePage=='geometra-squadra'}]">
                  <router-link :to="{name: 'geometra-squadra'}" >Geometra - Squadra</router-link>
                </li>
              </ul>
            </li>
            <!-- Logout -->
            <li class="has-submenu" :class="[{'active': activeDirectory=='profile'}]">
              <a href="#">
                <i class="ti-user"></i>Account
              </a>
              <ul class="submenu">
                <li :class="[{'active': activePage=='change-password'}]">
                  <router-link :to="{name: 'change-password'}" >Cambia Password</router-link>
                </li>
                 <li >
                  <a href="#" @click="platformLogout">Logout</a>
                </li>
              </ul>
            </li>
            <li class="has-submenu" :class="[{'active': activeDirectory=='monitoring'}]">
              <a href="https://www.system.innovambiente.it">
                <i class="ti-download"></i>Monitoring
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: ["activeDirectory", "activePage"],

  data () {
    return {
      notifications: [],
      tipologia: localStorage.getItem('tipologia')
    }    
  },

  methods: {
    // Mostra le notifiche
    showNotifications () {
      // this.$swal.fire(
      //   'The Internet?',
      //   'That thing is still around?',
      //   'question'
      // )
    },

    // Cancella il token ed effettua il logout
    platformLogout () {
      localStorage.removeItem('token')
      localStorage.removeItem('tipologia')
      this.$router.go()
    }
  }
};
</script>

<style>
</style>